import type { MouseEventHandler } from "react";
import { SquarePenIcon } from "lucide-react";

import { COARSE_POINTER_HIT_AREA_CLASS } from "~/lib/touchTarget";
import { Tooltip, TooltipPopup, TooltipTrigger } from "../ui/tooltip";

interface SidebarProjectNewThreadButtonProps {
  readonly ariaDisabled: boolean;
  readonly canCreateThread: boolean;
  readonly label: string;
  readonly onClick: MouseEventHandler<HTMLButtonElement>;
  readonly tooltip: string;
}

export function SidebarProjectNewThreadButton({
  ariaDisabled,
  canCreateThread,
  label,
  onClick,
  tooltip,
}: SidebarProjectNewThreadButtonProps) {
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <button
            type="button"
            aria-label={label}
            aria-disabled={ariaDisabled}
            data-testid="new-thread-button"
            className={`${COARSE_POINTER_HIT_AREA_CLASS} inline-flex size-5 items-center justify-center rounded-md text-muted-foreground/65 transition-colors hover:bg-secondary hover:text-foreground focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring ${
              canCreateThread ? "cursor-pointer opacity-100" : "cursor-not-allowed opacity-50"
            }`}
            onClick={onClick}
          />
        }
      >
        <SquarePenIcon className="size-3.5" />
      </TooltipTrigger>
      <TooltipPopup side="top">{tooltip}</TooltipPopup>
    </Tooltip>
  );
}
